<template>
  <div id="reportsContainer" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img src="../assets/images/navbar/ic_reports.webp" class="icon-pages" />
        <span class="page-title">{{ $t('page.reports') }}</span>
        <div class="page-des-line">
          <span class="page-des ml-10"
            >{{ $t('page.reports_description') }}</span
          >
        </div>
      </div>

      <div v-if="!userPermLock('reports')"> 
        <el-tabs class="style-bar" v-model="activeName">
          <el-tab-pane label="Daily" name="daily" default>
            <span slot="label" class="title-bar">{{ $t('page.daily') }}</span>
            <daily></daily>
          </el-tab-pane>
          <el-tab-pane label="Weekly" name="weekly">
            <span slot="label" class="title-bar">{{ $t('page.weekly') }}</span>
            <weekly></weekly>
          </el-tab-pane>
          <el-tab-pane label="Monthly" name="monthly">
            <span slot="label" class="title-bar">{{ $t('page.monthly') }}</span>
            <monthly></monthly>
          </el-tab-pane>
          <el-tab-pane label="Generate" name="generate">
            <span slot="label" class="title-bar">Generate</span>
            <quarterly></quarterly>
          </el-tab-pane>
        </el-tabs>
      </div>
      <page-locked v-else></page-locked>
    </div>
  </div>
</template>

<script>
export default {
  name: "members",
  components: {
    daily: require("./reports/daily").default,
    weekly: require("./reports/weekly").default,
    monthly: require("./reports/monthly").default,
    quarterly: require("./reports/quarterly").default,
    pageLocked: require("./main/page-locked").default,
  },
  created(){
    // this.$store.dispatch("reportPreview/getOrganization1level", this.user).then(()=>{
    //   this.$store.dispatch("reportPreview/getManagerOption", this.user)
    // });
  },
  watch: {
    activeName(value) {
      if (value != "") {
        const tab = this.activeName || "";
        const paramsTab = this.$router.currentRoute.params.tab;
        if (paramsTab != tab) {
          this.$router.push({ name: "reports", params: { tab } });
        }
      }
    },
  },
  data() {
    return {
      activeName: "daily",
      anchor: {
        daily: "daily",
        weekly: "weekly",
        monthly: "monthly",
        generate: "generate",
      },
    };
  },
  mounted() {
    const params = this.$router.currentRoute.params.tab;
    if (params && this.anchor[params]) {
      this.activeName = params;
    } else {
      this.$router.push({ name: 'reports', params: { tab: "daily" } })
    }
    this.$root.$on('changeTab', (item) => {
      if (item.path == "reports") {
        this.onChangedTab(item);
      }
    });
  },
  methods: {
    userPermLock() {
      return this.$utils("permissions", {
        perm: this.$store.getters["authen/pagePermission"],
        path: "reports",
        type: "lock",
        user_type: this.$store.getters["authen/user"].user_type
      });
    },
    onChangedTab(value) {
      this.activeName = value.tab;
    },
  },
};
</script>

<style scoped lang="scss">
</style>

<style lang="scss">
#reportsContainer {
  .engaged-container,
  .strengths-container,
  .growing-container,
  .connections-container,
  .insights-container {
    background-color: #fcfcfc;
    padding: 42px;
    width: calc(800px - 84px);
  }
  #dailyReports,
  #monthlyReports,
  #weeklyReports {
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 320px;
    }
    .el-input--prefix .el-input__inner {
      height: 52px;
      width: 320px;
      background-color: #f4f4f4;
      border-width: 0px;
      border-radius: 4px;
      font-size: 18px;
    }
    .el-cascader {
      .el-input__inner,
      .el-input {
        height: 52px;
        width: 320px;
        background-color: #f4f4f4;
        border-width: 0px;
        border-radius: 4px;
        font-size: 18px;
      }
    }
  }
}
#reportsContainer .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 150px;
  text-align: center;
}
#reportsContainer .el-tabs__header {
  margin: 0px;
}
</style>
